<div class="mat-dialog-container">
  <!-- 明細編輯開始 -->
  <div #head>
    <app-modal-header #modal_header [isDialog]="isDialog" [title]="title" [state]="srv.state" (onOkClick)="doOk($event)"
      (onEditAndSaveClick)="doEditAndSave($event)"
      (onCancelClick)="doCancel($event)">
    </app-modal-header>
  </div>
  <div class="jk-content">
    <div class="jk-grid-cols-4"> 
    <app-jkedit  label="主資料表" #SC001Com  id="SC001"  [(value)]="item.SC001" [required]="true"  placeholder="主資料表"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jktext  label="序號" [value]="item.SC002"     >
    </app-jktext>
    <app-jkedit  label="使用者代號" #SC003Com  id="SC003"  [(value)]="item.SC003" [required]="true"  placeholder="使用者代號"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="保留" #SC004Com  id="SC004"  [(value)]="item.SC004" placeholder="保留"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jktextarea  height="250px" 
 label="備註" #SC005Com  id="SC005"  [(value)]="item.SC005" placeholder="備註"  [readonly]="isBrowse"     >
    </app-jktextarea>

    </div>
  </div>
</div>